import React from 'react';

import cloneDeep from 'lodash/cloneDeep';

import { messages } from '@qality/common-messages';
import {
  StorageOfUniqueServices,
  TestCyclesService,
} from '@qality/common-service';

import { useTestCasesInCycleList } from '../testCasesInCycleList/TestCaseInCycleListProvider';
import { CloseReopenCycleView } from './CloseReopenCycle.view';

export const CloseReopenCycle: React.FC = () => {
  const { testCycleActions, testCycle } = useTestCasesInCycleList();

  const updateTestCycleState = async () => {
    try {
      const updatedTestCycle = cloneDeep(testCycle);
      updatedTestCycle.isClosed = !testCycle.isClosed;
      testCycleActions.updateTestCycle(updatedTestCycle);
      TestCyclesService.updateTestCycle(
        testCycle.id,
        updatedTestCycle.getRequestData()
      );
    } catch (e) {
      StorageOfUniqueServices.get('ErrorHandlingUtils').handleError(
        e,
        messages['testCycle.details.update.error']
      );
    }
  };

  return (
    <CloseReopenCycleView
      updateTestCycleState={updateTestCycleState}
      isClosed={testCycle.isClosed}
      canEdit={testCycle.canEdit}
    />
  );
};
